import { apiClient } from '@/api/client';
import type { TasteProfile, CuisineValence } from '@/types/taste-profile';
import { mapTasteProfileWireToDomain } from '../mappers/taste-profile';
import { tasteProfileWireSchema, type TasteProfileWire } from '../schemas/taste-profile';

/**
 * Domain-oriented API module for the current user's Taste Profile
 * (favorite/avoid cuisines, allergen avoidances, dietary adherences).
 * NOTE: unrelated to `taste.ts` / ProfileTaste (a rating distribution).
 */
const BASE = '/api/user/taste-profile';

export async function getTasteProfile(): Promise<TasteProfile> {
  const wire = await apiClient.get<TasteProfileWire>(BASE);
  return mapTasteProfileWireToDomain(tasteProfileWireSchema.parse(wire));
}

export async function addCuisinePreference(cuisineId: string, valence: CuisineValence): Promise<void> {
  await apiClient.post(`${BASE}/cuisines`, { cuisineId, valence });
}
export async function removeCuisinePreference(cuisineId: string): Promise<void> {
  await apiClient.delete(`${BASE}/cuisines/${encodeURIComponent(cuisineId)}`);
}
export async function addAllergen(allergenId: string): Promise<void> {
  await apiClient.post(`${BASE}/allergens`, { allergenId });
}
export async function removeAllergen(allergenId: string): Promise<void> {
  await apiClient.delete(`${BASE}/allergens/${encodeURIComponent(allergenId)}`);
}
export async function addDietaryProfile(dietaryProfileId: string): Promise<void> {
  await apiClient.post(`${BASE}/dietary-profiles`, { dietaryProfileId });
}
export async function removeDietaryProfile(dietaryProfileId: string): Promise<void> {
  await apiClient.delete(`${BASE}/dietary-profiles/${encodeURIComponent(dietaryProfileId)}`);
}
